import { validate } from 'uuid';
import mapHierarchicalChoices from '../sharedList/mapHierarchicalChoices';
import { Choice, HierarchicalDesc } from '90.quickConnect.Models/models';
import { flatten } from '80.quickConnect.Core/helpers';
import { MAX_HIERARCHICAL_PREFETCH } from '80.quickConnect.Core/const';
import { isApplicativeListId } from '80.quickConnect.Core/const/applicativeListIds';

const mapHierarchicalDesc = (field: HierarchicalDesc): HierarchicalDesc => {
  let listChoice;
  let listId;
  if (field.listDef) {
    if (validate(field.listDef) || isApplicativeListId(field.listDef)) {
      listId = field.listDef;
    } else {
      const parsed = JSON.parse(field.listDef);
      if (Array.isArray(parsed)) {
        const listLength = flatten(parsed, (n) => n?.children ?? []).filter(
          (n) => !n?.children || n.children.length === 0,
        ).length;
        if (listLength <= MAX_HIERARCHICAL_PREFETCH) {
          // petite ou moyenne liste -> on mappe
          listChoice = mapHierarchicalChoices(parsed as Choice[]);
        }
      }
    }
  }

  return {
    listDef: field.listDef,
    listChoice: field.listChoice ?? listChoice,
    listId: listId,
    isPopup: field.isPopup,
    defaultValue: field.defaultValue ?? undefined,
    multiSelection: field.multiSelection ?? false,
    isSearchable: field.isSearchable ?? false,
    value: field.value ?? [],
    filterDef: field.filterDef,
  } as HierarchicalDesc;
};

export default mapHierarchicalDesc;
